import { defineMessages } from 'react-intl';
import type { PipelineColumnKey } from './group-applied-jobs-by-pipeline-column';

/** Board column key including the "saved" lane, which sits outside the applicationState pipeline. */
export type BoardColumnKey = 'saved' | PipelineColumnKey;

export const PIPELINE_COLUMN_ORDER: PipelineColumnKey[] = ['applied', 'interviewing', 'offer', 'rejected', 'hired'];
export const BOARD_COLUMN_ORDER: BoardColumnKey[] = ['saved', ...PIPELINE_COLUMN_ORDER];

export const columnMessages = defineMessages({
  saved: {
    id: 'tools.kanban.column.saved',
    defaultMessage: 'Saved',
    description: 'Kanban column: saved jobs not yet in application pipeline',
  },
  applied: {
    id: 'tools.kanban.column.applied',
    defaultMessage: 'Applied',
    description: 'Kanban column: jobs with no further pipeline state',
  },
  interviewing: {
    id: 'tools.kanban.column.interviewing',
    defaultMessage: 'Interviewing',
    description: 'Kanban column: interviewing',
  },
  offer: {
    id: 'tools.kanban.column.offer',
    defaultMessage: 'Offer',
    description: 'Kanban column: offer',
  },
  rejected: {
    id: 'tools.kanban.column.rejected',
    defaultMessage: 'Rejected',
    description: 'Kanban column: rejected',
  },
  hired: {
    id: 'tools.kanban.column.hired',
    defaultMessage: 'Hired',
    description: 'Kanban column: hired',
  },
});

/**
 * Tailwind bg/text/border classes for stage pills & badges on the mobile pipeline list.
 * Uses jc-* CSS-var tokens so colors swap automatically in dark mode (no `dark:` needed).
 */
export const STAGE_BADGE_CLASSES: Record<BoardColumnKey, string> = {
  saved: 'bg-jc-gold-bg text-jc-gold border-jc-gold-line/40',
  applied: 'bg-jc-elevated text-jc-ink-secondary border-jc-border',
  interviewing: 'bg-jc-filter-location-bg text-jc-filter-location-text border-jc-filter-location-border/40',
  offer: 'bg-jc-filter-job-bg text-jc-filter-job-text border-jc-filter-job-border/40',
  rejected: 'bg-red-50 dark:bg-red-900/25 text-red-700 dark:text-red-300 border-red-200 dark:border-red-800',
  hired: 'bg-jc-accent-muted text-jc-accent border-jc-accent/40',
};

/** Just the background tokens from STAGE_BADGE_CLASSES, for the full-width draggable card banner. */
export const STAGE_BANNER_BG_CLASSES: Record<BoardColumnKey, string> = {
  saved: 'bg-jc-gold-bg',
  applied: 'bg-jc-elevated',
  interviewing: 'bg-jc-filter-location-bg',
  offer: 'bg-jc-filter-job-bg',
  rejected: 'bg-red-50 dark:bg-red-900/25',
  hired: 'bg-jc-accent-muted',
};
